import { backgroundBlue, blue, textMuted } from '@/theme/colors'
import { radii, motion } from '@/theme/tokens'
import styled from 'styled-components'
import { fontSizes } from '@/theme/typography'

export const DropZoneContainer = styled.div<{ $isExpanded?: boolean }>`
	height: ${({ $isExpanded }) => ($isExpanded ? '60px' : '0px')};
	margin: ${({ $isExpanded }) => ($isExpanded ? '6px 0' : '0px')};
	border-radius: ${radii.small};
	transition: all ${motion.base};
	background-color: ${({ $isExpanded }) => ($isExpanded ? backgroundBlue : 'transparent')};
	border: ${({ $isExpanded }) => ($isExpanded ? `2px dashed ${blue}` : 'none')};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${fontSizes.micro};
	color: ${({ $isExpanded }) => ($isExpanded ? blue : textMuted)};
	font-weight: 500;
	position: relative;
	min-width: 100%;
	overflow: hidden;
`
